/**
 * Empresa desta INSTALAÇÃO do ERP (VITE_EMPRESA_LOGIN, definida na geração — no piloto, pelo
 * deploy/piloto/piloto.json). Com ela, o login pede só usuário e senha; sem ela (null), a tela
 * volta a pedir o código da empresa. Não é segredo: só separa os usuários por empresa.
 */
import { loginCodeOfInstallation } from "@cafegestor/shared";

export const empresaDaInstalacao = (): string | null =>
  loginCodeOfInstallation(import.meta.env["VITE_EMPRESA_LOGIN"] as string | undefined);
